<template>
<div  id="Activitypeople">
  <v-header title="尊享服务客服导入"></v-header>
  <div class="ActivitypeopleCon">
    <div class="contentRight">
      <div class="rightcon">
        <el-row class="search">
          <el-col :span="8" class="">
            <el-row>
              <el-col :span="3">
                <span>姓名&nbsp;</span>
              </el-col>
              <el-col :span="17" class="">
                <el-input v-model="name" class="input" placeholder="请输入姓名"></el-input>
              </el-col>
            </el-row>
          </el-col>
          
          <el-col :span="8" class="">
            <el-row>
              <el-col :span="4">
                <span>证件号&nbsp;</span>
              </el-col>
              <el-col :span="17" class="">
                <el-input v-model="id" class="input" placeholder="请输入证件号"></el-input>          
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="2" ><el-button type="primary" @click="check()">查询</el-button></el-col>
          <el-col :span="6" class="">
            <!-- <el-button type="primary" @click="excel()" class="export floatRight" >导入</el-button> -->
            <el-upload class="upload-demo floatRight" :action="fileUrl" :data="uploadData" ref="uploadAgent" :on-success="uploadSuccess" :headers="uploadHeader" :show-file-list='false'>
              <el-button type="primary">导入</el-button>
            </el-upload>          
          </el-col>
        </el-row>

        <el-row style="margin-top:15px;">
        <el-col :span="24">
        <el-table class="tableCon"
            :data="tableData"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              prop="id"
              label="投保人客户号"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="name"
              label="投保人姓名"
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="idType"
              label="投保人证件类型"
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="idNo"
              label="投保人证件号"
              width='200'
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="phone"
              label="手机号"
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="vipLevel"
              label="享受尊享服务"
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="channel"
              label="VIP渠道"
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="team"
              label="机构"
              >
            </el-table-column>

          </el-table>
        </el-col>
        <el-col :span="24" class="pagesize pages" >
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="count">
          </el-pagination>
        </el-col>
        </el-row>
      </div>
    </div>
</div>
</div>
</template>
<script>
import url from '@/modules/url'
import api from '@/modules/api'
import getIP from '@/components/utils/getIP';
import vHeader from '@/layout/Header1.vue'
export default {
  components: {
    vHeader
  },
  name:'vip',
  data () {
    return {
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      name:'',
      id:'',
      count:0,
      uploadData: {
        domain: 'EXAM',
        buz: 'EXCEL',
        expired: 60,
        actions: '',
        buzId: '123',
        auth: 1
      },
      uploadHeader: {
        ComId: 'ebiz-agent',
        Authorization: 'Basic ' + sessionStorage.getItem('token'),
        'Accept-Device': 'NULL',
        'Accept-DeviceOS': 'NULL',
        'Accept-Location': 'NULL',
        'Accept-ISP': 'NULL',
        'Accept-StartTime': 'NULL',
        'Accept-TimeZone': -(new Date().getTimezoneOffset() * 60000),
        'Accept-Attr1': getIP.getBrowserInfo(),
        'Accept-Attr2': 'PC',
        'Accept-Attr3': '',
        'Real-Ip': getIP.getBrowserInfo(),
        'Accept-Attr4': 'NULL',
        'Accept-Attr6': sessionStorage.getItem('username')
      },
      fileUrl: ''
    }
  },
  methods: {
    uploadSuccess(res) {
      let that = this;
      if (res.result.isSuccess === true) {
        that.$refs.uploadAgent.clearFiles();
        // 上传完成，开始导入
        api.post(this.$url.importVipInfo, { url: api.urlDomin + res.data.fileId + '.' + res.data.ext }, function(res) {
          that.$message(res.result.error)
        });
      } else {
        that.$message.error(res.result.error);
        that.$refs.uploadAgent.clearFiles();
        // this.fileList = []
        // this.loading = false
      }
    },
    check () {
      this.currentPage=1
      this.getActivityGroupNumWithPage()
    },
    getActivityGroupNumWithPage () {
      let that = this
      const loading = that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      let options = {
        currentPage: that.currentPage,
        pageSize: 10,
        // name:this.name,
        // id:this.id
      }
      api.post(this.$url.getVipPersonInfoList,options, function (res) {
        console.log(res)
        if (res.result.isSuccess === true) {
          that.tableData = []
          res.data.records.map((item)=>{
            item.team=item.t2Name+'/'+item.t3Name
          })
          that.tableData = res.data.records
          that.count = Number(res.data.total)
          loading.close()
        } else {
          loading.close()
          alert('请求异常')
        }
      })
    },
    handleCurrentChange (val) {
      this.currentPage = val
      console.log(this.currentPage)
      this.getActivityGroupNumWithPage()
    },
  },
  mounted () {
    this.fileUrl = this.$uploadImg;
    let that = this
    const loading = that.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })

    api.post(this.$url.getImportState,{}, function (res) {
      console.log(res)
      if (res.result.isSuccess === true) {
        loading.close()
        if(res.data.length!=0){
          let text=''
          res.data.forEach(element => {
            text=text+'<p>您在'+element.importDate+'导入的文件,'+(element.state=='SUCCESS'?'导入成功。</p>':(element.state=='IMPORTING'?'正在导入。</p>':'导入失败。</p>'))
          });
          that.$alert(text, '温馨提示', {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true,
            callback: action => {
            }
          });
        }
        that.getActivityGroupNumWithPage()
      } else {
        loading.close()
        alert('请求异常')
      }
    })
    
  }

}
</script>

<style lang="scss" scoped>
#Activitypeople{
  padding-top: 60px;
  height:100%;
  box-sizing: border-box;
}
.ActivitypeopleCon{
  height: calc(100% - 100px);
  padding-top: 20px;
  // overflow: hidden;
  /* min-height: 100%; */
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.contentRight{
  width:100%;
  float: left;
  // padding-top: 20px;
}
.rightcon{
  width: 96%;
  margin: 0 auto;
}
.tableCon{
  margin-top: 20px;
}
// .exportBtn{ margin-top: 20px;}
.pages{
  display:flex;
  justify-content: center;
  align-items:center;
  background-color: #ffffff;
  height: 100px;
}
label{
    float: left;
    display: block;
    width: 31%;
    color: #919191;
}

.el-col {
    border-radius: 4px;
}
.pagesize{
  margin-bottom: 20px
}
#Activitypeople /deep/ .el-pagination{
  text-align: center!important
}
.search{
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/vip.vue